import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { InputGeneralComponent } from 'app/components/input-general/input-general.component';

@Component({
    selector: 'app-reset-password-status',
    templateUrl: './reset-password-status.component.html',
    standalone: true,
    imports: [
        InputGeneralComponent,
        MatIconModule,
        CommonModule,
        TranslateModule,
    ],
    styles: [
        `
            :host {
                width: 100%;
            }
        `,
    ],
})
export class ResetPasswordStatusComponent {
    constructor(private router: Router) {}

    goToSignIn() {
        this.router.navigate(['/login']);
    }
}
